var map = {
	"./2024_Jun_1.png": 1829,
	"./2024_Jun_2.png": 1454,
	"./2024_Jun_3.png": 7239,
	"./2024_Jun_4.png": 7624,
	"./2024_Jun_7.png": 9603,
	"./2024_May_1.png": 3017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6868;